module.exports = __webpack_public_path__ + "static/P2101547-9ac495d426e47397fa107d775e3be9ed.jpg";